// extracted by mini-css-extract-plugin
export default {"name":"Location_name__iO51P","row":"Location_row__UdFWM"};